import React from 'react';
import { Grid, Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import GridsGallerySkeleton from 'views/common/components/UI/GridsGallery/GridsGallerySkeleton';

const MotorcycleTripsSectionSkeleton = () => (
  <Box>
    <Grid container justifyContent="space-between" mb={1}>
      <Grid item xs="9">
        <Skeleton variant="text" width="70%" height={40} />
      </Grid>
      <Grid item xs="3" lg="2">
        <Grid container spacing={1}>
          <Grid item xs="3">
            <Skeleton variant="text" width="100%" height={40} />
          </Grid>
          <Grid item xs="3">
            <Skeleton variant="text" width="100%" height={40} />
          </Grid>
          <Grid item xs="3">
            <Skeleton variant="text" width="100%" height={40} />
          </Grid>
          <Grid item xs="3">
            <Skeleton variant="text" width="100%" height={40} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>

    <Skeleton variant="text" width="100%" height={15} />
    <Skeleton variant="text" width="40%" height={15} />
    <Skeleton variant="text" width="70%" height={15} />
    <Skeleton variant="text" width="100%" height={15} />
    <Skeleton variant="text" width="60%" height={15} mb={2} />
    <GridsGallerySkeleton variant="tours" mt={2} />
  </Box>
);
export { MotorcycleTripsSectionSkeleton };
